import { NavLink } from 'react-router-dom';
import { Icon, type IconName } from './Icon.js';

/** Five destinations, matching the product design. */
const ITEMS: { to: string; label: string; icon: IconName }[] = [
  { to: '/transactions', label: 'עסקאות', icon: 'transactions' },
  { to: '/budget', label: 'תקציב', icon: 'budget' },
  { to: '/', label: 'דאשבורד', icon: 'dashboard' },
  { to: '/goals', label: 'יעדים', icon: 'goals' },
  { to: '/profile', label: 'פרופיל', icon: 'profile' },
];

export function BottomNav() {
  return (
    <nav className="bottom-nav" aria-label="ניווט ראשי">
      <div className="bottom-nav__inner">
        {ITEMS.map((item) => (
          <NavLink key={item.to} to={item.to} end={item.to === '/'} className="nav-item">
            {({ isActive }) => (
              <>
                <Icon name={item.icon} size={22} strokeWidth={isActive ? 2.1 : 1.8} />
                <span>{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

export function Sidebar() {
  return (
    <nav className="sidebar" aria-label="ניווט ראשי">
      <div className="sidebar__brand">הכסף שלי</div>
      {ITEMS.map((item) => (
        <NavLink key={item.to} to={item.to} end={item.to === '/'} className="nav-item">
          <Icon name={item.icon} size={20} />
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
